<script>
import { mapGetters } from 'vuex'

import Choices from 'choices.js'

export default {
  data: function () {
    return {
      picker: null,
    }
  },
  computed: {
    ...mapGetters('translations', [
        'currentLanguage',
        'languagesList'
    ])
  },
  watch: {
      immediate: true,
      'currentLanguage': function () {
      this.picker.clearChoices()
      this.picker.setChoices(this.languageDataAdapter())
    },

  },
  // beforeCreate() {
  //   this.$store.subscribe(((mutation, state) => {
  //     if (mutation.type === 'translations/SET_AVAILABLE_LANGUAGES') {
  //       this.picker.clearChoices()
  //       this.picker.setChoices(this.languageDataAdapter())
  //       document.querySelector('.selected-language').innerHTML = this.currentLanguage
  //     }
  //   }))
  // },
  // mounted() {
  //   this.picker = new Choices('#language-select', {
  //     searchEnabled: false,
  //     classNames: {
  //       containerOuter: 'language-select',
  //       containerInner: 'inner-select',
  //       listDropdown: 'languages',
  //       list: 'languages-list',
  //       item: 'language',
  //       listSingle: 'selected-language'
  //     }
  //   })

  //   if (this.languagesList.length) {
  //     this.picker.clearChoices()
  //     this.picker.setChoices(this.languageDataAdapter())
  //     document.querySelector('.selected-language').innerHTML = this.currentLanguage
  //   }

  //   this.$refs.languageSelect.addEventListener('change', event => {
  //     const lang = event.detail.value
  //     document.querySelector('.selected-language').innerHTML = lang
  //     this.$store.commit('translations/SET_LANGUAGE', lang)
  //   })
  // },


  // updated() {
  //   // if (this.$refs.languageSelect && !this.picker) {
  //   //   this.picker.clearChoices()
  //   //   this.picker.setChoices(this.languageDataAdapter())
  //   //   document.querySelector('.selected-language').innerHTML = this.currentLanguage
  //   // }
  // },
  beforeCreate() {
    // this.$store.subscribe(((mutation, state) => {
    //   if (mutation.type === 'translations/SET_AVAILABLE_LANGUAGES') {
    //     this.picker.clearChoices()
    //     this.picker.setChoices(this.languageDataAdapter())
    //     document.querySelector('.selected-language').innerHTML = this.currentLanguage
    //   }
    // }))
  },
  mounted() {
    if (this.$refs.languageSelect) {
      this.picker = new Choices(this.$refs.languageSelect, {
        searchEnabled: false,
        shouldSort: false,
        classNames: {
          containerOuter: 'language-select',
          containerInner: 'inner-select',
          listDropdown: 'languages',
          list: 'languages-list',
          item: 'language',
          listSingle: 'selected-language'
        }
      })

      this.$nextTick(() => {
        this.picker.clearChoices()
        this.picker.setChoices(this.languageDataAdapter())
      })
    }

    this.$refs.languageSelect.addEventListener('change', event => {
      const lang = event.detail.value
      this.$store.commit('translations/SET_LANGUAGE', lang)
      this.$store.commit('translations/SET_IS_TRANSLATED', true)
    })
  },
  methods: {
    languageDataAdapter() {
      return this.languagesList.map(lang => {
        return {
          value: lang.alpha2code,
          label: lang.title,
          selected: lang.alpha2code === this.currentLanguage
        }
      })
    }
  }
}
</script>

<template>
  <div class="picker-container">
    <label for="language-select"></label>
    <select id="language-select" ref="languageSelect" name="language"></select>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
  .selected-language {
    margin-right: 4px;
    padding-left: 16.5px;
    width: auto;
  }

::v-deep .language-select {
  min-width: 65px;
  padding: 0 20px;
  height: 35px;
  background-color: $dark-blue;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 15px;
  line-height: 35px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  cursor: pointer;

  position: relative;

  &:hover {
    background-color: $hover-blue;
  }

  &.is-open {
    border-color: $dark-blue;
  }

  /* white */

  color: #FFFFFF;

  & .inner-select {
    text-transform: uppercase;
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:after {
      content: '';
      background: url("../../assets/icons/down-arrow.svg") center no-repeat;
      width: 8px;
      height: 6px;
      margin-left: 4px;
    }
  }

  & .languages {
    position: absolute;
    top: 40px;
    right: 0;
    width: 127px;
    background: $dark-blue;
    visibility: hidden;
    border-radius: 5px;
    z-index: 10000;

    & .language {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
      text-align: left;
      color: white;

      box-sizing: border-box;
      padding-left: 12px;
      padding-top: 5px;
      padding-bottom: 5px;

      &:last-child {
        padding-bottom: 9px;
      }
    }

    &.is-active {
      visibility: visible;
    }
  }
}
</style>
